// 기사님이 직접 정한 배송 순서를 기기에 저장한다.
// 배송묶음 id(delivery_id)는 배송예정일마다 새로 생기므로 날짜와 함께 저장하고,
// 날짜가 다르면 지난 순서로 보고 무시한다.
const STORAGE_KEY = 'deliveryOrder';

// 저장된 순서를 읽는다. 없거나 다른 날짜의 순서면 null.
// 개인정보 보호 모드 등에서는 localStorage 접근 자체가 실패할 수 있어 감싼다.
export function loadDeliveryOrder(deliveryDate) {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved?.date !== deliveryDate || !Array.isArray(saved.ids)) {
      return null;
    }
    return saved.ids;
  } catch (error) {
    return null;
  }
}

export function saveDeliveryOrder(deliveryDate, ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ date: deliveryDate, ids }));
  } catch (error) {
    // 저장에 실패해도 이번 화면에서는 바뀐 순서가 그대로 유지된다
    console.warn('배송 순서 저장 실패:', error);
  }
}

export function clearDeliveryOrder() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('배송 순서 초기화 실패:', error);
  }
}

// 저장된 순서대로 정렬한다.
// 저장 목록에 없는 배송묶음(새로 배정됐거나 아직 순서를 정하지 않은 것)은
// 서버가 내려준 순서를 유지한 채 맨 뒤에 붙인다.
export function applyDeliveryOrder(deliveries, orderedIds) {
  if (!orderedIds || orderedIds.length === 0) {
    return deliveries;
  }

  const position = new Map(orderedIds.map((id, index) => [id, index]));
  const known = [];
  const unknown = [];

  deliveries.forEach(delivery => {
    if (position.has(delivery.delivery_id)) {
      known.push(delivery);
    } else {
      unknown.push(delivery);
    }
  });

  known.sort((a, b) => position.get(a.delivery_id) - position.get(b.delivery_id));
  return [...known, ...unknown];
}
